// Lib
import React, { ReactElement } from 'react';

// Hooks
import {
    useActiveTiptapEditorCallback,
    ActiveTiptapEditorSelector,
    useTiptapActiveEditorSelector,
} from '../../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import TextColorButton from './TextColorButton';

const isTextColorButtonActive =
    (color: string | null): ActiveTiptapEditorSelector =>
    (editor) => {
        if (color === null) {
            return !editor?.isActive('textStyle') && !editor?.isActive('highlight');
        }

        return editor?.isActive('textStyle', { color });
    };

interface TiptapTextColorButtonProps {
    color: string | null;
    customTextColor?: string | null;
    customBackgroundColor?: string | null;
}

const TiptapTextColorButton = (props: TiptapTextColorButtonProps): ReactElement => {
    const { color, customTextColor, customBackgroundColor } = props;

    const active = useTiptapActiveEditorSelector(isTextColorButtonActive(color));

    const onTextColorClick = useActiveTiptapEditorCallback((activeEditor) => {
        if (!color) return activeEditor?.chain().unsetColor().unsetHighlight().run();

        return activeEditor?.chain().setColor(color).run();
    });

    return (
        <TextColorButton
            active={active || false}
            color={color}
            className={color ? `text-${color}` : 'text-default'}
            onSelectTextColor={onTextColorClick}
            customTextColor={customTextColor}
            customBackgroundColor={customBackgroundColor}
        />
    );
};

export default TiptapTextColorButton;
